import React, { useEffect } from "react";

const ShelfTabs = ({ shelves, selectedShelf, onShelfSelect }) => {
  // Automatically select the first shelf when shelves change
  useEffect(() => {
    if (shelves.length > 0 && !selectedShelf) {
      onShelfSelect(shelves[0].shelf_name);
    }
  }, [shelves, selectedShelf, onShelfSelect]);

  return (
    <div className="mb-6 border-b">
      <div className="flex">
        {shelves.map((shelf) => (
          <button
            key={shelf.shelf_name}
            onClick={() => onShelfSelect(shelf.shelf_name)}
            className={`px-4 py-2 text-sm font-medium ${
              selectedShelf === shelf.shelf_name
                ? "border-b-4 border-[#4CAF50] text-[#4CAF50]"
                : "text-gray-600 hover:text-[#4CAF50]"
            }`}
          >
            {shelf.shelf_name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ShelfTabs;
